<template>
    <el-dialog  title="新增Icon" :visible.sync="showBlock" :destroy-on-close="true" :close-on-click-modal="false" width="400px" :before-close="closedBtn">
        <el-form :model="formDate" ref="formDate" status-icon :rules="rules" label-width="50px" class="demo-ruleForm">
            <el-form-item label="类型">
                <el-select v-model="formDate.code" placeholder="请选择ICON" style="width:100%;">
                    <el-option  v-for="item in listIcon" :key="item.val" :label="item.title" :value="item.val" :disabled="item.mak"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item  label="Icon" prop="logo">
                <UpLoadImng width="76" height="76" size="1" :showMark="false" keyVal="icon" limit="1" rules="jpg,gif,png" @getUpload="getUpload" />
            </el-form-item>
            <el-form-item  label="描述" >
                <el-input  type="textarea" v-model="formDate.marks" :size="this.$store.state.popSize" maxlength="20" show-word-limit :rows="2"  placeholder="请输入内容"></el-input>
            </el-form-item>
            <div class="warp-btn">
                <el-form-item>
                    <div  class="dialog-footer">
                        <el-button @click="closedBtn">取消</el-button>
                        <el-button type="primary" @click="submitForm('formDate')">提交</el-button>
                    </div>
                </el-form-item>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
  import {url,iotApi} from '@/utils/config'
  import {postFun,putFun} from '@/utils/httpFun'
  import UpLoadImng from '@/components/component-block/block-uploadImg.vue'
  let checklogo = function(rule, value, callback){
    if (!value) {
        return callback(new Error("icon不可为空"));
    }
    callback()    
  }

  export default{
    components:{
        UpLoadImng:UpLoadImng
    },
     data:()=>({
        rules:{

             logo:[{validator:checklogo, trigger:'change'}],
        },
        title:"",
        listIcon:[],
        formDate: {
            code:"",       
            dtId: "",
            id:1,
            operator:"",
            marks:"",
            logo:"",
        },
        showBlock: false
     }),
    
     created(){
       
     },
     methods:{
    

        //上传ICON
        getUpload(ev){
            this.formDate.logo=ev.val[0]
        },

        //提交
        submitForm(formDate) {
            this.$refs[formDate].validate((valid) => {
            if (valid) {
                  this.addMess()
                } else {
                  console.log('error submit!!');
                  return false;
                }
            });
        },

        //提交新增
        async addMess(){
            let parms = { 
                code:this.formDate.code,
                dtId:this.formDate.dtId,
                remarks:this.formDate.marks,
                resource:this.formDate.logo,
            }
            parms.operator = this.$store.state.operator
            await postFun(iotApi.ICONADD,parms,res=>{
               this.$parent.getList()
               this.closedBtn()    
            })
        },

        //开启弹窗
        showBlockMe(ev){
           this.title = ev.name+"添加Icon"
           this.showBlock = true 
           this.listIcon = ev.listIcon
           this.formDate.code = ev.IconCode
           this.formDate.dtId = ev.id
           
        },
        
        //关闭弹窗并刷新
        closedBtn(){
            this.formDate.name = ''
            this.formDate.code = ""
            this.formDate.marks=''
            this.formDate.logo = ''
            this.formDate.orderNo = 1
            this.showBlock = false
        },
        handleChange(){
            
        }
     }
  }
</script>
<style scoped lang="scss">
   .dialog-footer{
       display: flex;
       justify-content: flex-end;
   }

   .name{
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #4D5C72;
        letter-spacing: 0;
   }


   .warp-btn{
    .el-form-item {
        margin-bottom:0px!important;
     }
   }
   
</style>